class JSONEditingError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
    }
}

export { JSONEditingError };
